<div class="map-action" (click)="mergeMap()">
    <span class="icon-ui-directions2"></span> Merge Another Map
</div>
